import { IPartialReducer } from "../../../core/core-redux/reduxTypes";
import { ChangesType } from "../../types";
import { updateObject } from "../../../common/util/UpdateObject";

export const changesLoadedPartialReducer: IPartialReducer<ChangesType> = (state) => {
    return updateObject(state, {
        changesLoad: {
            loading: false,
        },
    });
};
